const wowApp = require('angular').module('wowApp.common');
wowApp.directive('bwsAccordionGroup', [require('./accordion-group.js')]);
wowApp.directive('bwsAccordionHeader', [require('./accordion-header.js')]);
wowApp.directive('bwsAccordionBody', [require('./accordion-body.js')]);
wowApp.directive('bwsAccordion', [require('./accordion.js')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/accordion/index.js
 **/